/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 11:38:03
 * @LastEditTime: 2022-06-06 15:59:23
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/Components/SendTime/index.tsx
 */
import { Select } from '@/src/components/Antd';
import { TimePicker } from 'antd';
import moment from 'moment';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { ITime } from 'src/types/common/report';
import css from './css.module.less';
interface IProps {
  value?;
  onChange?;
  disabled?: boolean;
}

export const unitOptions = ({ getI18n }) => [
  {
    label: getI18n(
      'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.daily',
    ),
    value: ITime.Days,
  },
  {
    label: getI18n(
      'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Weekly',
    ),
    value: ITime.Weeks,
  },
  {
    label: getI18n(
      'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Monthly',
    ),
    value: ITime.Months,
  },
];

const isLastOptions = ({ getI18n }) => [
  {
    label: getI18n(
      'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.First',
    ),
    value: false,
  },
  {
    label: getI18n(
      'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Last',
    ),
    value: true,
  },
];

const weekOptions = (unit, { getI18n }) => {
  const _weeks = [
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Monday',
      ),
      value: 0,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Tuesday',
      ),
      value: 1,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Wednesday',
      ),
      value: 2,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Thursday',
      ),
      value: 3,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Friday',
      ),
      value: 4,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Saturday',
      ),
      value: 5,
    },
    {
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.Sunday',
      ),
      value: 6,
    },
  ];
  if (unit !== ITime.Weeks) {
    _weeks.unshift({
      label: getI18n(
        'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.CalendarDay',
      ),
      value: -1,
    });
  }
  return _weeks;
};

const SendTime = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, disabled } = props;
  const { unit = '', day = '', last = '', time = '' } = value || {};

  const handleTimeChange = (e) => {
    onChange({ ...value, time: e ? e.format('HH:mm') : null });
  };
  const handleTypeChange = (e) => {
    const params = { ...value, unit: e };
    if (e === ITime.Weeks && params.day === -1) {
      params.day = 0;
    }
    onChange(params);
  };

  const handleDateChange = (e) => {
    onChange({ ...value, day: e });
  };
  const handleOrderChange = (e) => {
    onChange({ ...value, last: e });
  };

  return (
    <div className={css.sendTime}>
      <Select
        formProps={{ className: css.iTime }}
        value={unit}
        optionsList={unitOptions({ getI18n })}
        size='large'
        onChange={handleTypeChange}
        disabled={disabled}
      />
      {(unit === ITime.Months || unit === ITime.Weeks) && (
        <span className={css.text}>
          {unit === ITime.Months
            ? getI18n(
                'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.onthe',
              )
            : getI18n(
                'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.on',
              )}
        </span>
      )}
      {unit === ITime.Months && (
        <Select
          formProps={{ className: css.iTime }}
          value={last}
          onChange={handleOrderChange}
          optionsList={isLastOptions({ getI18n })}
          size='large'
          disabled={disabled}
        />
      )}
      {(unit === ITime.Months || unit === ITime.Weeks) && (
        <Select
          formProps={{ className: css.date }}
          value={day}
          optionsList={weekOptions(unit, { getI18n })}
          onChange={handleDateChange}
          size='large'
          disabled={disabled}
        />
      )}
      {unit && (
        <span className={css.text}>
          {getI18n(
            'reportSubscription.reportSubscriptionDetail.innercomponets.Sendtime.at',
          )}
        </span>
      )}
      {unit && (
        <TimePicker
          format='HH:mm'
          size='large'
          className={css.iTime}
          onChange={handleTimeChange}
          value={time && moment(time, 'HH:mm')}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default SendTime;
